import { useState, useEffect } from 'react';
import debounce from 'debounce';
import { isClientSide } from '../../lib';

const ONE_HUNDRED = 100;

export interface WindowSize {
  width: number;
  height: number;
}

const getWindowSize = (): WindowSize =>
  isClientSide()
    ? { width: window.innerWidth, height: window.innerHeight }
    : { width: 0, height: 0 };

export const useWindowSize = (): WindowSize => {
  const [size, setSize] = useState<WindowSize>(getWindowSize());
  const updateSize = (): void => setSize(getWindowSize());
  const debouncedUpdateSize = debounce(updateSize, ONE_HUNDRED);

  useEffect(() => {
    if (!isClientSide()) return;

    window.addEventListener('resize', debouncedUpdateSize);
    window.addEventListener('orientationchange', debouncedUpdateSize);

    return (): void => {
      window.removeEventListener('resize', debouncedUpdateSize);
      window.removeEventListener('orientationchange', debouncedUpdateSize);
    };
  }, [debouncedUpdateSize]);

  return size;
};
